// search drawer web components, with smooth animation and keyboard support
// has open state, and close state, ferforms fetch request to fetch search results
// navigates to search results page when more results button is shown
(() => {
    const template = document.createElement('template');
    template.innerHTML = `
    <style>
    :host {
      display: block;
    }

    .search-drawer {
      position: fixed;
      top: var(--top-offset);
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      height: calc(100% - var(--top-offset));
      display: none;
      background: rgba(0, 0, 0, 0.5);
    }
    .search-drawer-body {
      overflow: auto;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: auto;
      max-height: 100%;
      margin: 0 auto;
      background: var(--background, #fff);
      box-sizing: border-box;
      box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.2);
    }

    </style>
    <div class="search-drawer">
      <div class="search-drawer-body">
        <slot name="body"></slot>
      </div>
    </div>
  `;

    class SearchDrawer extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.cachedResults = {};
            this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
            this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
            this.isOpen = false;
            this.abortController = new AbortController();
            this.searchTerm = '';
            this.shadowRoot.appendChild(template.content.cloneNode(true));
            this.searchDrawer = this.shadowRoot.querySelector('.search-drawer');
            this.searchControls = this.searchDrawer.querySelector('.search-drawer-body')
            const openBtns = document.querySelectorAll('.search-bar__toggle');
            this.input = this.querySelector('.search-bar__input');
            this.form = this.input.closest('form');
            this.search_url = this.form.dataset.predictiveSearchUrl;
            this.returnFocusTo = null;

            this.clearBtn = document.querySelector('.search-bar__clear');

            // Close search drawer when clicking outside the search drawer
            this.searchDrawer.addEventListener('click', e => {
                if (e.target === this.searchDrawer) {
                    this.close();
                }
            });

            // Close search drawer when pressing the escape key
            document.addEventListener('keydown', e => {
                // if (e.key === 'Enter') {
                //     e.preventDefault();
                //     e.stopPropagation();
                //     this.onChange()
                // }
                if (e.key === 'Escape') {
                    this.close();
                }
            });

            // Open search drawer when clicking on the search icon
            openBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.returnFocusTo = btn;
                    this.toggle();
                });
            });
            this.clearBtn.addEventListener('click', () => {
                this.input.value = '';
                this.searchTerm = '';
                this.predictiveSearchResults.innerHTML = " "
                this.input.focus()
                this.searchTerm = '';
                this.abortController.abort();
                this.abortController = new AbortController();
            });

            this.setupEventListeners();
            this.classList.remove('hide');
        }

        setupEventListeners() {
            this.form.addEventListener('submit', this.onFormSubmit.bind(this));
            // this.input.addEventListener('change', this.onChange.bind(this));
            this.input.addEventListener('input', this.onChange.bind(this));
            this.addEventListener('focusout', this.onFocusOut.bind(this));
            this.input.addEventListener('keyup', this.onKeyup.bind(this));
            // this.addEventListener('keydown', this.onKeydown.bind(this));
        }

        open() {
            const header = document.querySelector('header') && document.querySelector('header').getBoundingClientRect();
            if (header) {
                this.style.setProperty('--top-offset', `${header.top}px`);
            }

            this.searchDrawer.style.display = 'block';
            document.body.style.overflow = 'hidden';
            // this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
            this.setAttribute('open', true);
            this.input.setAttribute('aria-expanded', true);
            this.isOpen = true;
            window.input = this.input;
            this.trapFocus(document.getElementById('search-modal'), true);
            // window.setTimeout(() => {
            //     this.input.focus()
            // }, 500)

        }

        getQuery() {
            return this.input.value.trim();
        }

        onChange() {

            const newSearchTerm = this.getQuery();

            if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
                // Remove the results when they are no longer relevant for the new search term
                // so they don't show up when the dropdown opens again
                this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
            }

            // Update the term asap, don't wait for the predictive search query to finish loading
            this.updateSearchForTerm(this.searchTerm, newSearchTerm);

            this.searchTerm = newSearchTerm;

            if (!this.searchTerm.length) {
                this.clearBtn.classList.add('hide')
                return;
            } else {
                this.clearBtn.classList.remove('hide')
            }

            this.getSearchResults(this.searchTerm);
        }


        onFormSubmit(event) {
            event.preventDefault();
            if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
        }

        onFormReset(event) {
            super.onFormReset(event);
            if (super.shouldResetForm()) {
                this.searchTerm = '';
                this.abortController.abort();
                this.abortController = new AbortController();
                this.closeResults(true);
            }
        }

        onFocusOut() {
            setTimeout(() => {
                //  if (!this.contains(document.activeElement)) this.close();
            });
        }

        onKeyup(event) {

            switch (event.code) {
                case 'Enter':
                    event.preventDefault();
                    event.stopPropagation();
                    break;
            }
        }

        onKeydown(event) {
            // Prevent the cursor from moving in the input when using the up and down arrow keys
            if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
                event.preventDefault();
            }
        }

        updateSearchForTerm(previousTerm, newTerm) {
            const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
            const currentButtonText = searchForTextElement?.innerText;
            if (currentButtonText) {
                const newButtonText = currentButtonText.replace(previousTerm, newTerm);
                searchForTextElement.innerText = newButtonText;
            }
        }

        switchOption(direction) {
            if (!this.getAttribute('open')) return;

            const moveUp = direction === 'up';
            const selectedElement = this.querySelector('[aria-selected="true"]');

            // Filter out hidden elements (duplicated page and article resources) thanks
            // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
            const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
                (element) => element.offsetParent !== null
            );
            let activeElementIndex = 0;

            if (moveUp && !selectedElement) return;

            let selectedElementIndex = -1;
            let i = 0;

            while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
                if (allVisibleElements[i] === selectedElement) {
                    selectedElementIndex = i;
                }
                i++;
            }

            this.statusElement.textContent = '';

            if (!moveUp && selectedElement) {
                activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
            } else if (moveUp) {
                activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
            }

            if (activeElementIndex === selectedElementIndex) return;

            const activeElement = allVisibleElements[activeElementIndex];

            activeElement.setAttribute('aria-selected', true);
            if (selectedElement) selectedElement.setAttribute('aria-selected', false);

            this.input.setAttribute('aria-activedescendant', activeElement.id);
        }

        selectOption() {
            const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

            if (selectedOption) selectedOption.click();
        }

        getSearchResults(searchTerm) {
            const queryKey = searchTerm.replace(' ', '-').toLowerCase();
            this.setLiveRegionLoadingState();

            if (this.cachedResults[queryKey]) {
                this.renderSearchResults(this.cachedResults[queryKey], searchTerm);
                return;
            }

            fetch(`${this.search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,tag,product_type,variants.title&section_id=main-search-predictive`, {
                signal: this.abortController.signal,
            })
                .then((response) => {
                    if (!response.ok) {
                        var error = new Error(response.status);

                        throw error;
                    }

                    return response.text();
                })
                .then((text) => {
                    const resultsMarkup = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('#predictive-search-results').innerHTML;
                    // Save bandwidth keeping the cache in all instances synced

                    this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
                    });
                    this.renderSearchResults(resultsMarkup, searchTerm);
                })
                .catch((error) => {
                    if (error?.code === 20) {

                        return;
                    }
                    throw error;
                });
        }

        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
            this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

            this.setLiveRegionText(this.loadingText);
            this.setAttribute('loading', true);
        }

        setLiveRegionText(statusText) {
            this.statusElement.setAttribute('aria-hidden', 'false');
            this.statusElement.textContent = statusText;

            setTimeout(() => {
                this.statusElement.setAttribute('aria-hidden', 'true');
            }, 1000);
        }

        renderSearchResults(resultsMarkup, searchTerm = "") {
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.setAttribute('results', true);

            const newDestiny = this.predictiveSearchResults.querySelector(`a[data-title="${searchTerm.toLowerCase().trim()}"]`)

            if (newDestiny) {
                newDestiny.click();
            }
            window.initCartPopupProductDetails_popUp();
            window.sections.register("product-card", theme.ProductCard);
            this.setLiveRegionResults();
            this.trapFocus(document.getElementById('search-modal'), false);
        }

        setLiveRegionResults() {
            this.removeAttribute('loading');
        }

        getResultsMaxHeight() {
            this.resultsMaxHeight =
                window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
            return this.resultsMaxHeight;
        }



        close(clearSearchTerm = false) {
            this.closeResults(clearSearchTerm);
            this.isOpen = false;
            this.searchDrawer.style.display = 'none';
            document.body.style.overflow = 'auto';
            this.returnFocusTo?.focus();
            this.returnFocusTo = null;
        }

        closeResults(clearSearchTerm = false) {
            if (clearSearchTerm) {
                this.input.value = '';
                this.removeAttribute('results');
            }
            const selected = this.querySelector('[aria-selected="true"]');

            if (selected) selected.setAttribute('aria-selected', false);

            this.input.setAttribute('aria-activedescendant', '');
            this.removeAttribute('loading');
            this.removeAttribute('open');
            this.input.setAttribute('aria-expanded', false);
            this.resultsMaxHeight = false;
            this.predictiveSearchResults.removeAttribute('style');
        }


        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        }

        trapFocus(trap, focusFirst = true) {
            // predictive seach content can change, so we need to query these every time the trap is called
            // get all focusable elements in the trap
            function getFocusableElements() {
                return trap.querySelectorAll('button:not([tabindex="-1"]), a[href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe');
            }
            // get first element to be focused inside trap;
            function getFirstFocusableElement() {
                return getFocusableElements()[0];
            }
            // get last element to be focused inside trap
            function getLastFocusableElement() {
                const focusableContent = getFocusableElements();
                return focusableContent[focusableContent.length - 1];
            }

            function handleKeyDown(e) {
                const firstFocusableElement = getFirstFocusableElement();
                const lastFocusableElement = getLastFocusableElement();
                let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed) {
                    return;
                }
                if (e.shiftKey) { // if shift key pressed for shift + tab combination
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus(); // add focus for the last focusable element
                        e.preventDefault();
                    }
                } else { // if tab key is pressed
                    if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        firstFocusableElement.focus(); // add focus for the first focusable element
                        e.preventDefault();
                    }
                }
            }

            // clear previously-set focusable element loop
            document.removeEventListener('keydown', handleKeyDown);

            // create the element loop
            document.addEventListener('keydown', handleKeyDown);

            // support auto focus when opening the trap
            if (focusFirst) {
                const firstFocusableElement = getFirstFocusableElement();
                setTimeout(() => {
                    firstFocusableElement.focus();
                }, 350);
            }
        }
    }

    window.customElements.define('search-drawer', SearchDrawer);
})();
